import type { SVGProps, ComponentType } from 'react';
import { HomeIcon } from './icons/HomeIcon';
import { CalendarIcon } from './icons/CalendarIcon';
import { BriefcaseIcon } from './icons/BriefcaseIcon';
import { ShoppingBagIcon } from './icons/ShoppingBagIcon';
import { UsersIcon } from './icons/UsersIcon';
import { CreditCardIcon } from './icons/CreditCardIcon';
import { PaletteIcon } from './icons/PaletteIcon';

export interface NavItem {
  to: string;
  label: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  desktopOnly?: boolean;
}

export const navItems: NavItem[] = [
  { to: '/home', label: 'Home', Icon: HomeIcon },
  { to: '/programs', label: 'Programs', Icon: CalendarIcon },
  { to: '/themes', label: 'Themes', Icon: PaletteIcon, desktopOnly: true },
  { to: '/organizers', label: 'Organizers', Icon: BriefcaseIcon },
  { to: '/merchants', label: 'Vendors', Icon: ShoppingBagIcon },
  { to: '/guests', label: 'Members', Icon: UsersIcon },
  { to: '/transactions', label: 'Transactions', Icon: CreditCardIcon },
];
